import { trigger, state, style, transition, animate } from '@angular/animations';
import { formatNumber } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit, DOCUMENT } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { AppService, GRSSResponse, ValueIdPair } from 'src/app/_services/app.service';
import { MonitorComponent } from '../monitor.component';
import { ContributionConfirmComponent } from './contribution-confirm/contribution-confirm.component';

@Component({
    selector: 'app-market-contribute',
    templateUrl: './market-contribute.component.html',
    styleUrls: ['./market-contribute.component.css'],
    animations: [
        trigger('slider', [
            state('*', style({
                height: 0
            })),
            state('show', style({
                height: '*'
            })),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ])
    ],
    standalone: false
})
export class MarketContributeComponent implements OnInit, OnDestroy {

  contributeMarket: ContributeMarket;
  contributeMarketTemp: ContributeMarket;

  contributionsLength: number = 0;
  instrumentLength: number = 0;
  timeToOpenOrClose: string;
  displayColumnsAllTransact: string[] = ['name', 'space', 'level', 'cof', 'spread', 'reason', 'fsaCOF', 'newVolume'];
  displayColumnsAll: string[] = ['name', 'space', 'newRate', 'newVolume'];
  displayColumns: string[] = ['name', 'newRate'];
  dataSourceNew;
  canEnablebtnSubmit: boolean = true;
  hasSubmitted: boolean = false;
  currentTimeColumn: string = '';
  username: string = '';
  contributorCode: string = 'Contributor';
  intervals: any[] = [];

  reasons: ValueIdPair[] = [];
  isTransactional: boolean = false;

  isLoading: boolean = false;
  hasMaxHeight: boolean = false;

  // tslint:disable-next-line: max-line-length
  constructor(private translate: TranslateService, @Inject(DOCUMENT) private document: Document, @Inject(LOCALE_ID) public localeID: string, public dialogRef: MatDialogRef<MonitorComponent>, @Inject(MAT_DIALOG_DATA) public data, private dialog: MatDialog, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private service: AppService) {
  }

  ngOnInit() {
    this.service.needTemplate = false;
    this.InitializeMarket();
    // this.route.queryParams.subscribe(params => {
    this.contributorCode = this.data.market.contributor;
    this.contributeMarket.marketId = this.data.marketId;
    this.isTransactional = this.data.isTransactional;
    this.username = this.data.market.relatedUserInfo[0].username;
    this.GetContributions();
    this.GetReasons();
    const interval = setInterval(() => {
      this.service.GetRemainingTime(this.contributeMarket.marketId, 'Contribution StartOrOverrideFinish').then(res => {
        this.timeToOpenOrClose = res.time;
        if (this.currentTimeColumn === '') {
          this.currentTimeColumn = res.timeColumn;
        } else if ((this.currentTimeColumn !== res.timeColumn) || res.time.split('0').join('').replace(/\:/gi, '').trim() === '') {
          if (this.currentTimeColumn === 'Contribution Start' && res.timeColumn === 'Override Finish') {
            this.GetContributions();
          } else if ((this.currentTimeColumn === 'Override Finish' && res.timeColumn === 'Contribution Start') || res.timeColumn === 'Override Finish') {
            this.contributeMarket.isMarketOpen = false;
            this.contributeMarketTemp.isMarketOpen = false;
          }
          this.currentTimeColumn = res.timeColumn;
        }
      });
    }, 1000);
    this.intervals.push(interval);

    if ((window.innerHeight > 700) === false) {
      this.hasMaxHeight = true;
    }
    // });
  }

  ngOnDestroy() {
    if (this.intervals.length > 0) {
      this.intervals.forEach(interval => {
        clearInterval(interval);
      });
    }
  }

  /** Initializes the market details */
  InitializeMarket() {
    this.contributeMarket = {
      marketId: '',
      marketCode: '',
      isMarketOpen: false,
      isTransactional: false,
      canEnableBtnDiscard: false,
      hasDiscardIssues: true,
      instruments: null,
      conflicted: false
    };
  }

  /** Gets the list of reasons */
  GetReasons() {
    this.http.get<ValueIdPair[]>(this.baseUrl + 'api/contribute/getReasons').subscribe(result => {
      this.reasons = result;
    }, error => {
      console.error(error);
    });
  }

  /** Gets the contribution details */
  GetContributions() {
    this.isLoading = true;
    this.http.get<ContributeMarket>(this.baseUrl + 'api/monitorMarkets/getContributions/' + this.contributeMarket.marketId + '/' + this.username).subscribe(result => {
      // let initialAssign: boolean = false;

      this.contributeMarket = result;
      if (this.isTransactional === true) {
        this.displayColumns = this.displayColumnsAllTransact;
      } else {
        this.displayColumns = this.displayColumnsAll;
      }

      let hasVolume: boolean = false;
      // let hasAssessed: boolean = false;
      // let hasCurrentRate: boolean = false;

      let canDiscard: boolean = true;
      this.contributeMarket.instruments.forEach(i => {
        i.newRate = i.rate;
        i.newVolume = i.volume;

        if (i.calculationType === 'wav') {
          hasVolume = true;
        }

        if (Number(i.spread) == Number(i.defaultSpread)) {
          i.listReasonId = '';
          i.isReasonRequired = false;
        } else {
          i.isReasonRequired = true;
        }

        if (i.decimalPlaces) {
          i.decimalPlacesStep = (Math.round(0 * 100) / 100).toFixed(i.decimalPlaces).toString().replace(/.$/, '1');
        }

        if (!i.newRate) {
          canDiscard = false;
        }
      });

      // Disable discard button when already discarded
      if (this.contributeMarket.canEnableBtnDiscard === true && canDiscard !== true) {
        this.contributeMarket.canEnableBtnDiscard = false;
      }

      this.FormatNumbers(0);

      if (hasVolume === false) {
        const volumeItems: string[] = ['newVolume'];
        this.displayColumns = this.displayColumns.filter(f => !volumeItems.includes(f));
      }

      this.contributeMarketTemp = JSON.parse(JSON.stringify(this.contributeMarket));

      this.instrumentLength = this.contributeMarket.instruments.length;
      this.dataSourceNew = new MatTableDataSource(this.contributeMarket.instruments);
    }, error => {
      console.error(error);
    }).add(() => {
      this.isLoading = false;
    });
  }

  /**
   *  Formats the numbers according to the culture chages
   * @param from
   */
  FormatNumbers(from: number) {

    this.contributeMarket.instruments.forEach(i => {
      if (i.decimalPlaces && i.newRate) {
        i.fsaCOF = (Number(i.newRate) + Number(i.spread)).toString();

        let temp = i.newRate.replace('-', '');
        let beforeDec = temp.split('.')[0].length.toString();
        i.newRate = formatNumber(Number(i.newRate), this.localeID, beforeDec + '.' + i.decimalPlaces + '-' + i.decimalPlaces);
        if (i.level === 3 || i.level === 0) {
          i.assessedRate = formatNumber(Number(i.assessedRate), this.localeID, beforeDec + '.' + i.decimalPlaces + '-' + i.decimalPlaces);
        }

        i.rate = i.newRate;

        temp = i.fsaCOF.replace('-', '');
        beforeDec = temp.split('.')[0].length.toString();
        i.fsaCOF = formatNumber(Number(i.fsaCOF), this.localeID, beforeDec + '.' + i.decimalPlaces + '-' + i.decimalPlaces);
      }

      let temp = i.spread.replace('-', '');
      let beforeDec = temp.split('.')[0].length.toString();
      let afterDec = temp.split('.')[1].length.toString();
      i.spread = formatNumber(Number(i.spread), this.localeID, beforeDec + '.' + afterDec + '-' + afterDec);
      i.newSpread = i.spread;

      if (i.previousRate) {
        temp = i.previousRate.replace('-', '');
        let parts = temp.split('.');
        beforeDec = parts[0].length.toString();
        afterDec = parts[1] ? parts[1].length.toString() : '0';
        i.previousRate = formatNumber(Number(i.previousRate), this.localeID, beforeDec + '.' + afterDec + '-' + afterDec);
      }
      
      if (i.defaultSpread) {
        temp = i.defaultSpread.replace('-', '');
        beforeDec = temp.split('.')[0].length.toString();
        afterDec = temp.split('.')[1].length.toString();
        i.defaultSpread = formatNumber(Number(i.defaultSpread), this.localeID, beforeDec + '.' + afterDec + '-' + afterDec);
      }
    });
  }

  /** Control enabling of submit button */
  EnablebtnSubmit(element: ContributeMarketRecord) {
    // this.canEnablebtnSubmit = this.CheckInputs(element);
    if (element) {
      this.calculateFSACOF(element);
    }
  }
  
  /** Check the possibility of submit */
  CanSubmit(): string {
    let status = '';
    this.contributeMarket.instruments.forEach(i => {

      this.checkSpread(i);

      if (i.isReasonRequired && !i.listReasonId && this.contributeMarket.isTransactional) {
        if (status !== '') {
          status += ', ';
        }
        status += i.instrumentDescription;
      }
    });

    return status;
  }

  /**
   *  Calculates the FSACOF rate
   * @param element
   */
  calculateFSACOF(element: ContributeMarketRecord) {
    const tempContribution: ContributeMarketRecordEdit = {
      defaultSpread: element.spread,
      comments: element.comments,
      fsaCOF: element.fsaCOF,
      level: element.level,
      rate: element.newRate,
      reasonId: element.listReasonId,
      spread: element.newSpread,
      response: null,
      marketId: this.contributeMarket.marketId
    };
    this.http.post<ContributeMarketRecordEdit>(this.baseUrl + 'api/contribute/formatTransactNumbers', tempContribution).subscribe(result => {
      if (result.response.statusCode === 1) {let temp: string;
        let beforeDec;
        let afterDec;
  
        if (result.fsaCOF) {
          temp = result.fsaCOF.replace('-', '');
          if (!temp.includes('.')) {
            afterDec = 0;
            beforeDec = temp.length;
          } else {
            beforeDec = temp.split('.')[0].length.toString();
            afterDec = temp.split('.')[1].length.toString();
          }
          result.fsaCOF = formatNumber(Number(result.fsaCOF), this.localeID, beforeDec + '.' + afterDec + '-' + afterDec);
        }
  
        if (result.rate) {
          temp = result.rate.replace('-', '');
          if (!temp.includes('.')) {
            afterDec = 0;
            beforeDec = temp.length;
          } else {
            beforeDec = temp.split('.')[0].length.toString();
            afterDec = temp.split('.')[1].length.toString();
          }
          result.rate = formatNumber(Number(result.rate), this.localeID, beforeDec + '.' + afterDec + '-' + afterDec);
        }
  
        if (result.spread) {
          temp = result.spread.replace('-', '');
          if (!temp.includes('.')) {
            afterDec = 0;
            beforeDec = temp.length;
          } else {
            beforeDec = temp.split('.')[0].length.toString();
            afterDec = temp.split('.')[1].length.toString();
          }
          result.spread = formatNumber(Number(result.spread), this.localeID, beforeDec + '.' + afterDec + '-' + afterDec);
        }
  
        element.newSpread = result.spread;
        element.newRate = result.rate;
        element.fsaCOF = result.fsaCOF;
      } else {
        this.service.SaveStatus(false, this.translate.instant('MarketMonitor.monitor.Messages.msgHeaderSubmitRates'), result.response.statusMessage, true);
      }
    }, error => {
      console.error(error);
    });
  }

  /** Submit button event */
  OnSubmitClick() {
    const status = this.CanSubmit();
    // if (this.canEnablebtnSubmit) {
    if (status === '') {
      this.hasSubmitted = true;
      const tempInstruments: ContributeMarketRecord[] = JSON.parse(JSON.stringify(this.contributeMarket.instruments));
      this.contributeMarket.instruments.forEach(o => {
        o.rate = o.newRate;
        o.volume = o.newVolume;
        o.spread = o.newSpread;
      });
      this.contributeMarketTemp.instruments.forEach(o => {
        o.rate = o.newRate;
        o.volume = o.newVolume;
        o.spread = o.newSpread;
      });
      this.http.post<VerifyResponse>(this.baseUrl + 'api/contribute/verfiyRatesOperator/' + this.username, this.contributeMarket).subscribe(re => {
        this.contributeMarket.conflicted = re.conflicted;
        if (re.response.statusCode === 1) {
          this.dialog.open(ContributionConfirmComponent, {
            disableClose: true,
            data: {
              title: this.translate.instant('MarketMonitor.monitor.Messages.msdHeaderConfirmSub'),
              message: re.response.statusMessage + this.translate.instant('MarketMonitor.monitor.Messages.msgParaSubmitRates'),
              innerHTML: true
            },
            position: { top: '5%' }
          }).afterClosed().subscribe(res => {
            // Evaluate the users response.
            if (res.trim() !== '') {
              this.contributeMarket.instruments.forEach(o => {
                o.rate = o.newRate;
                o.volume = o.newVolume;
                o.spread = o.newSpread;
              });
              this.contributeMarketTemp.instruments.forEach(o => {
                o.rate = o.newRate;
                o.volume = o.newVolume;
                o.spread = o.newSpread;
              });

              this.service.showSpinner();
              this.http.post<GRSSResponse>(this.baseUrl + 'api/monitorMarkets/submitRates/' + this.username + '/' + res, this.contributeMarket).subscribe(result => {
                if (result.statusCode === 1) {
                  this.hasSubmitted = false;
                  // this.GetContributions();
                  this.service.SaveStatus(false, 'MarketMonitor.monitor.Messages.msgHeaderSubmitRates', result.statusMessage);
                  this.dialogRef.close(1);
                } else if (result.statusCode === 4) {
                  this.service.SaveStatus(true, 'MarketMonitor.monitor.Messages.msgHeaderSubmitRates', result.statusMessage);
                } else {
                  this.service.SaveStatus(false, 'MarketMonitor.monitor.Messages.msgHeaderSubmitRates', result.statusMessage);
                }
              }, error => {
                console.error(error);
              }).add(() => {
                this.service.hideSpinner();
              });
            } else {
              this.contributeMarket.instruments = tempInstruments;
              this.contributeMarketTemp.instruments = tempInstruments;
              this.dataSourceNew = new MatTableDataSource(this.contributeMarket.instruments);
            }
          });
        } else if (re.response.statusCode === 4) {
          this.service.SaveStatus(true, 'MarketMonitor.monitor.Messages.msgHeaderSubmitRates', re.response.statusMessage);
        } else {
          // this.contributeMarket.instruments = tempInstruments;
          this.service.SaveStatus(false, this.translate.instant('MarketMonitor.monitor.Messages.msgHeaderSubmitRates'), re.response.statusMessage, true);
          this.dataSourceNew = new MatTableDataSource(this.contributeMarket.instruments);
        }

        this.contributeMarket.instruments.forEach(o => {
          o.newRate = o.rate;
          o.newVolume = o.volume;
          o.newSpread = o.spread;
        });
        this.contributeMarketTemp.instruments.forEach(o => {
          o.newRate = o.rate;
          o.newVolume = o.volume;
          o.newSpread = o.spread;
        });
      }, error => {
        console.error(error);
      });
    } else {
      this.service.SaveStatus(false, this.translate.instant('MarketMonitor.monitor.Messages.msgHeaderSubmitRates'), 'Please add a reason or reasons for changing the spread of following tenors. <br>' + status, true);
    }
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close(0);
  }

  /** Discard button event */
  OnDiscard() {
    let details: string = '';
    if (this.contributeMarket.hasDiscardIssues === true) {
      details = '<label class="text-danger">' + this.translate.instant('MarketMonitor.monitor.Messages.msgWarningDiscard') + '</label><br>';
    }
    this.dialog.open(ContributionConfirmComponent, {
      disableClose: true,
      data: {
        title: this.translate.instant('MarketMonitor.monitor.Messages.msdHeaderConfirmSub'),
        message: details + this.translate.instant('MarketMonitor.monitor.Messages.msgParaDiscardRates'),
        innerHTML: true
      },
      position: { top: '5%' }
    }).afterClosed().subscribe(res => {
      if (res.trim() !== '') {
        this.service.showSpinner();
        this.http.get<GRSSResponse>(this.baseUrl + 'api/monitorMarkets/discardRates/' + this.contributeMarket.instruments[0].submissionInstrumentId + '/' + res).subscribe(result => {
          if (result.statusCode === 1) {
            this.service.SaveStatus(false, 'MarketMonitor.monitor.Messages.msgHeaderSubmitRates', result.statusMessage);
            this.dialogRef.close(1);
          } else if (result.statusCode === 4) {
            this.service.SaveStatus(true, 'MarketMonitor.monitor.Messages.msgHeaderSubmitRates', result.statusMessage);
          } else {
            this.service.SaveStatus(false, 'MarketMonitor.monitor.Messages.msgHeaderSubmitRates', result.statusMessage);
          }
        }, error => {
          console.error(error);
        }).add(() => {
          this.service.hideSpinner();
        });
      }
    });
  }

  /**
   * Checks the spread and resets the reson code
   * @param element Selected contribution
   */
  checkSpread(element: ContributeMarketRecord) {
    // Resetting the reason code
    if (Number(element.newSpread) == Number(element.defaultSpread)) {
      element.listReasonId = '';
      element.isReasonRequired = false;
    } else {
      element.isReasonRequired = true;
    }
  }
}

/** An interface to access contribute market details */
interface ContributeMarket {
  marketId: string;
  marketCode: string;
  isMarketOpen: boolean;
  isTransactional: boolean;
  canEnableBtnDiscard: boolean;
  hasDiscardIssues: boolean;
  conflicted: boolean;
  instruments: ContributeMarketRecord[];
}

/** An inteface to access contribute market record */
interface ContributeMarketRecord {
  listReasonId: string;
  isReasonRequired: boolean;
  submissionInstrumentId: string;
  instrumentId: string;
  instrumentDescription: string;
  defaultSpread: string;
  level: number;
  spread: string;
  newSpread: string;
  fsaCOF: string;
  rate?: string;
  volume?: number;
  comments: string;
  assessedRate?: string;
  assessedVolume?: number;
  previousRate?: string;
  previousVolume?: number;
  notes: string;
  status: string;
  calculationType: string;
  newRate: string;
  newVolume: number;
  decimalPlaces: number;
  decimalPlacesStep: string;
}

/** An interface to access a record of a market contribution */
interface ContributeMarketRecordEdit {
  defaultSpread: string;
  spread: string;
  rate: string;
  fsaCOF: string;
  comments: string;
  level: number;
  reasonId: string;
  response: GRSSResponse;
  marketId: string;
}

/** Interface to access the response of the verify rates */
interface VerifyResponse {
  conflicted: boolean;
  response: GRSSResponse;
}
